import dream_gaming_casino_img from "../../assets/images/dream_gaming_casino_img.png";
import GameCard from "../GameCard";
import React, { useEffect, useState } from "react";

const CasinoTabCardsSection = () => {
  const [casinoData, setCasinoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCasinoData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/games/casino`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch casino data");
        }
        const data = await response.json();
        setCasinoData(data.lists);
        // setCasinoData(data.lists.slice(0, 9));
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCasinoData();
  }, []);

  if (loading) return <p className="text-center">Loading casinos...</p>;
  if (error) return <p className="text-center text-red-500">Error: {error}</p>;
  return (
    <>
      {casinoData.map((item, index) => (
        <GameCard
          game={item}
          key={index}
        />
      ))}
    </>
  );
};

export default CasinoTabCardsSection;
